type Role = 'admin' | 'rmc'

export const ENDPOINTS = {
  LOGIN: '/admin/auth/login',
  FETCH_PROPERTIES: (horId: Number, role: Role = 'admin') =>
    `/admin/${role}/hors/${horId}/search-included`,
  FETCH_HOR: (horId: Number, role: Role = 'admin') =>
    `/admin/${role}/hors/${horId}`,
  UPDATE_PROPERTIES: (horId: Number, role: Role = 'admin') =>
    `/admin/${role}/hors/${horId}/rmc-property-list`,
  SEND_TO_EMPLOYEE: (horId: Number, role: Role = 'admin') =>
    `/admin/${role}/hors/${horId}/send-to-employee`,
  SEARCH_CONFIG: () => '/admin/search/config',
  USER: () => '/admin/user',
  GET_LOCATION_DISTANCES: (y1: number, x1: number, x2: number, y2: number) =>
    `/admin/search/distance?x1=${x1}&y1=${y1}&x2=${x2}&y2=${y2}`,
  CREATE_HOR: (role: Role = 'admin') => `/admin/${role}/hors`,
  CONFIG: () => '/admin/config',
  COMPANIES: (role: Role = 'admin', rmcId?: number | string) => {
    if (role === 'admin') {
      return '/admin/admin/companies'
    }
    return `/admin/rmc/${rmcId ? `${rmcId}` : 'rmc'}/companies`
  },
}
